export const DESIGN_TOOL_OPTIONS_DISABLED_TOOLTIP =
  "This design isn't compatible with the Design Tool yet.";

export const MTO_GROUP_ADD_DISABLED_TOOLTIP =
  "MTO products can't be grouped. Create a separate design instead.";
